export const FETCH_LOCATION_BY_ZIP = "location/fetch_by_zip";
export const FETCH_LOCATION_BY_ZIP_DONE = "location/fetch_by_zip_done";
export const FETCH_LOCATION_BY_ZIP_FAILED = "location/fetch_by_zip_failed";
export const UPDATE_LOCATION = "location/update_location";
export const FETCH_MSA_CODE_BY_ZIP = "/locations/fetch_msa_code_by_zip";
export const FETCH_MSA_CODE_BY_ZIP_DONE =
  "/locations/fetch_msa_code_by_zip_done";
export const FETCH_MSA_CODE_BY_ZIP_FAILED =
  "/locations/fetch_msa_code_by_zip_failed";
